import {
  CreateEvaluationFormTemplateDocument,
  CreateEvaluationFormTemplateMutationVariables,
  GetEvaluationFormTemplatesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateEvaluationFormTemplate = () => {
  const [createForm, { loading }] = useMutation(CreateEvaluationFormTemplateDocument, {
    extractorFn: (data) => data.atsMutations.createAtsEvaluationForm,
  })

  return {
    loading,
    create(variables: CreateEvaluationFormTemplateMutationVariables) {
      return createForm({
        variables,
        refetchQueries: [GetEvaluationFormTemplatesDocument],
        awaitRefetchQueries: true,
      })
    },
  }
}
